import i18n from '@/utils/i18n';
import store from '../../store'

export default {
  // 当前班次信息
  classesName() {
    const currentClasses = store.getters.userShifts
    if (currentClasses) {
      return currentClasses.name
    }
    return undefined
  },
  /*
  * 打印设置信息
  * */
  printSetting() {
    return this.$store.getters.printSettings || {}
  },
  // 基础设置信息
  baseInfoSettings() {
    return this.$store.state.app.baseInfoSettings
  },

  taxMode() {
    // return 1
    return this.$store.state.app.baseInfoSettings?.taxMode
  },
  
  taxConfig() { 
    return this.$store.state.user.taxConfig;
    // return {
    //   businessFeeUnit: 2,
    //   amount: 5,
    // }
  }
}
